export const apiPath = '/v1/imports';
const actionType = 'IMPORTS';

export default actionType;
